import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isFadingOut, setIsFadingOut] = useState(false);
  const n = 4;
  const m = Math.pow(n, 2);

  useEffect(() => {
    // Show loading screen for 5 seconds
    const timer = setTimeout(() => {
      setIsFadingOut(true);
      // Call onComplete callback after fade out animation
      setTimeout(() => {
        setIsVisible(false);
        if (onComplete) {
          onComplete();
        }
      }, 500); // Wait for fade out animation to complete
    }, 5000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  // Generate cubes with proper --i and --j values
  const cubes = [];
  for (let i = 0; i < m; i++) {
    const row = Math.floor(i / n);
    const col = i % n;
    cubes.push(
      <div
        key={i}
        className="cube"
        style={{
          '--i': col,
          '--j': row,
        }}
      />
    );
  }

  if (!isVisible) {
    return null;
  }

  return (
    <div className={`loading-screen ${isFadingOut ? 'fade-out' : ''}`}>
      <div className="loading-content">
        {/* Logo Container with Writing Animation — temporarily disabled */}
        {/* <div className="logo-container">
          <div className="logo-wrapper">
            <img
              // src="/mos-logo_svg.svg"
              src="/mos-logo.png"
              alt="MOS Logo"
              className="logo-image"
            />
          </div>
        </div> */}

        {/* Cube Animation — temporarily disabled */}
        {/* <div className="cube-animation-container">
          <div className="grid" style={{ '--n': n }}>
            {cubes}
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default LoadingScreen;

